export default __webpack_public_path__ + "static/media/info03_Documentos_adjuntos.f7af96df.png";